module.exports = __webpack_public_path__ + "montserrat-regular-webfont.b03e6057ab991eb8c96c.woff";


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/assets/fonts/montserrat-regular-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-regular-webfont.woff
// module chunks = main